export enum Direction {
    LEFT,
    RIGHT,
    UP,
    DOWN,
    NONE
}
